function SystemSettingsReducer(state = {
  serviceExtraAttrSettings: [], systemSettings: [], printTemplate: '',
  printViewPopStatus: '', currentVersion: '', preCustomerExtAttrSettings: [], customerExtAttrSettings: [], activeSubsystems: [], appModules: {Data:-1}
}, action) {
  switch (action.type) {
    case "GET_EXT_SETTINGS":
      return {
        ...state,
        serviceExtraAttrSettings: action.data
      }
    case "GET_PRECUSTOMER_EXT_SETTINGS":
      return {
        ...state,
        preCustomerExtAttrSettings: action.data
      }
    case "GET_CUSTOMER_EXT_SETTINGS":
      return {
        ...state,
        customerExtAttrSettings: action.data
      }
    case "GET_SYSTEM_SETTINGS":
      return {
        ...state,
        systemSettings: action.data
      }
    case "GET_PRINT_TEMPLATE":
      return {
        ...state,
        printTemplate: action.data
      }
    case "PRINT_VIEW_POPSTATUS":
      return {
        ...state,
        printViewPopStatus: action.data
      }
    case "CHECK_VERSION":
      return {
        ...state,
        currentVersion: action.data
      }
    case "GET_ACTIVE_SUBSYSTEMS":
      return {
        ...state,
        activeSubsystems: action.data
      }
    case "GET_APP_CONFIG":
      return {
        ...state,
        appModules: action.data
      }
    default:
      return state;
  }

}
export default SystemSettingsReducer;